import { render, staticRenderFns } from "./BankingInformation.vue?vue&type=template&id=84c84328&scoped=true"
import script from "./BankingInformation.vue?vue&type=script&lang=js"
export * from "./BankingInformation.vue?vue&type=script&lang=js"
import style0 from "./BankingInformation.vue?vue&type=style&index=0&id=84c84328&prod&lang=css"
import style1 from "./BankingInformation.vue?vue&type=style&index=1&id=84c84328&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c84328",
  null
  
)

export default component.exports